import React from "react";
import StoreMap from "../StoreMap";
import { FiMapPin, FiPhone, FiMail, FiMessageCircle } from "react-icons/fi";
import { Link } from "react-router-dom";

const whatsapp =
  "https://wa.me/18764482032?text=Hello%2C%20I%20would%20like%20help%20with%20a%20product%20or%20order.";

export default function ContactSection() {
  return (
    <main className="ct-page">
      <section className="ct-hero">
        <div className="ct-wrap company-hero-grid"><div className="company-hero-copy">
          <p className="ct-eyebrow">CONTACT TECHNOGENIOUS</p>
          <h1>
            A real conversation.
            <br />
            <span>The right solution.</span>
          </h1>
          <p>
            Need a part, help with your gaming machine, or an update on your order?
            Get in touch with our team in Kingston.
          </p>
          <div className="ct-actions">
            <a
              className="ct-primary"
              href={whatsapp}
              target="_blank"
              rel="noopener noreferrer"
            >
              Chat on WhatsApp ↗
            </a>
            <a href="tel:+18766484163">Call +1 (876) 648-4163</a>
          </div>
        </div>
          <div className="company-visual company-contact"><FiMapPin aria-hidden="true" /><span className="company-location">KINGSTON, JAMAICA</span><strong>Let’s talk about<br />your next setup.</strong><span>Shop 4B, 17 Molynes Road</span><div className="company-contact-icons" aria-hidden="true"><FiPhone /><FiMail /><FiMessageCircle /></div></div>
        </div>
      </section>
      <div className="ct-wrap ct-content">
        <section aria-labelledby="ct-reach">
          <h2 id="ct-reach">Choose how to reach us</h2>
          <div className="ct-grid">
            <article className="ct-card">
              <span className="company-icon" aria-hidden="true"><FiPhone /></span><p className="ct-label">LET’S TALK</p>
              <h3>Call the store</h3>
              <p>
                Speak with our team about products, pickup, or technical
                support.
              </p>
              <a href="tel:+18766484163">+1 (876) 648-4163</a>
              <a href="tel:+18764482032">+1 (876) 448-2032</a>
            </article>
            <article className="ct-card">
              <span className="company-icon" aria-hidden="true"><FiMail /></span><p className="ct-label">SEND THE DETAILS</p>
              <h3>Email our team</h3>
              <p>
                Include your product details or order reference so we can help.
              </p>
              <a href="mailto:technogeniousja@gmail.com">
                technogeniousja@gmail.com
              </a>
            </article>
            <article className="ct-card">
              <span className="company-icon" aria-hidden="true"><FiMessageCircle /></span><p className="ct-label">KEEP IN TOUCH</p>
              <h3>Message us</h3>
              <p>
                Ask about compatibility, gaming machine availability, or delivery
                options.
              </p>
              <a href={whatsapp} target="_blank" rel="noopener noreferrer">
                Open WhatsApp ↗
              </a>
              <a
                href="https://www.instagram.com/technogeniousja/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                Find us on Instagram ↗
              </a>
            </article>
          </div>
        </section>
        <section className="ct-visit" aria-labelledby="ct-visit-title">
          <div>
            <p className="ct-label">VISIT US IN KINGSTON</p>
            <h2 id="ct-visit-title">Your local point of contact.</h2>
            <address>
              Shop 4B, 17 Molynes Road
              <br />
              Kingston, Jamaica
            </address>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Shop%204B%2C%2017%20Molynes%20Road%2C%20Kingston%2C%20Jamaica"
              target="_blank"
              rel="noopener noreferrer"
            >
              View address on Google Maps ↗
            </a>
          </div>
          <div className="ct-hours">
            <h3>Store hours</h3>
            <p>Monday to Saturday</p>
            <strong>9:00 am to 6:00 pm</strong>
            <p>Call ahead to confirm holiday hours or arrange your visit.</p>
            <hr />
            <h3>Collect your order</h3>
            <p>
              Store pickup is free. Contact us to confirm your order is ready
              before travelling.
            </p>
          </div>
          <StoreMap />
        </section>
        <section className="ct-help" aria-labelledby="ct-help-title">
          <h2 id="ct-help-title">Help us understand what you need</h2>
          <div className="ct-grid">
            <div>
              <h3>Parts & compatibility</h3>
              <p>
                Have the gaming machine model, part number, and a clear photo ready.
              </p>
              <Link to="/products">Browse products →</Link>
            </div>
            <div>
              <h3>Orders & delivery</h3>
              <p>
                Include your order reference and delivery area. Courier charges
                are determined separately by the courier.
              </p>
              <Link to="/FAQs">Read frequently asked questions →</Link>
            </div>
            <div>
              <h3>Technical support</h3>
              <p>
                Describe the issue, when it started, and any error messages you
                see.
              </p>
              <Link to="/services">Explore our services →</Link>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
